import { AssociateTimeAttendanceEvents } from '../../../../common/components/modals/time-attendance-events/associate-time-attendance-events/AssociateTimeAttendanceEvents';
import { UpdateTimeAttendanceEvents } from '../../../../common/components/modals/time-attendance-events/modify-time-attendance-events/UpdateTimeAttendanceEvents';
import {
    TimeAttendanceEventsByEmployeeRequest,
    TimeAttendanceEventsRangeRequest,
} from '../../../../common/components/modals/time-attendance-events/TimeAttendanceEvent';
import { requests } from '../apiAgent';

export const TimeAttendanceEventsAPI = {
    createTimeAttendanceEvent: (event: AssociateTimeAttendanceEvents) => {
        return requests
            .post('/dublin/api/v2.0.0/events', event)
            .then((response) => response);
    },
    updateTimeAttendanceEvent: (event: UpdateTimeAttendanceEvents[]) => {
        return requests
            .put('/dublin/api/v2.0.0/events/', event)
            .then((response) => response);
    },
    getAllTimeAttendanceEventsByEmployee: (
        data: TimeAttendanceEventsByEmployeeRequest
    ) => {
        return requests
            .post('/dublin/api/v2.0.0/events/by-employee', data)
            .then((response) => response);
    },
    getAllTimeAttendanceEvents: (data: TimeAttendanceEventsRangeRequest) => {
        return requests
            .post('/dublin/api/v2.0.0/events/events-by-date-range-list', data)
            .then((response) => response);
    },
    deleteTimeAttendances: (eventsIds: number[]) => {
        return requests
            .deleteWithBody('/dublin/api/v2.0.0/events', { eventIds: eventsIds })
            .then((response) => response);
    },

    changeEventType: (event: { eventId: number; eventTypeId: number }) => {
        return requests
            .put('/dublin/api/v2.0.0/events/change-event-type-by-event', [event])
            .then((response) => response);
    },
};
